import { useAsyncFn } from 'react-use';
import { processGuestAmendment } from './processGuestAmendment';
import { SelfServiceAPI } from 'types';

interface Data extends SelfServiceAPI.CreateGuestAmendment.Request {
  bookingId: string;
}

const useCreateGuestAmendment = () => {
  const [{ loading, error }, createGuestAmendment] = useAsyncFn((data: Data) => processGuestAmendment(data), []);

  return {
    createGuestAmendment,
    loading,
    error: !!error,
  };
};

export default useCreateGuestAmendment;
